export { default as SmvThread } from './page'


// WEBPACK FOOTER //
// ./src/pages/SmvThread/index.js